var map = {
	"./angielski_pp.svg": 6835,
	"./biologia.svg": 6786,
	"./chemia.svg": 8127,
	"./fizyka.svg": 5195,
	"./geografia.svg": 4429,
	"./historia.svg": 3482,
	"./matematyka_pp.svg": 5239,
	"./matematyka_pr.svg": 5834,
	"images/svg/subjects/angielski_pp.svg": 6835,
	"images/svg/subjects/biologia.svg": 6786,
	"images/svg/subjects/chemia.svg": 8127,
	"images/svg/subjects/fizyka.svg": 5195,
	"images/svg/subjects/geografia.svg": 4429,
	"images/svg/subjects/historia.svg": 3482,
	"images/svg/subjects/matematyka_pp.svg": 5239,
	"images/svg/subjects/matematyka_pr.svg": 5834
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6957;